import { FC, useCallback } from "react"
import { MicroCopy, Options } from "../ContactForm/ContactForm"
import {
  Button,
  InlineAlert as MarmaladeInlineAlert,
  SelectField,
  HelpIcon,
  InfoIcon,
  Typography
} from "@eventbrite/marmalade"
import * as styles from "./SupportOptions.module.scss"
import { navigate } from "gatsby"
import classNames from "classnames"
import Lottie from "react-lottie"
import * as greenLoaderLottieData from "../../icons/lottie/GreenSpinner/Progress loading_circular_Green.json"

export type NonEnglishSupportOptionsCopy = {
  headerSupportOptions: MicroCopy
  messageSupportOptionsNonEnglish: MicroCopy
}

export type EnglishAttendeeSupportOptionsCopy = {
  headerSupportOptions: MicroCopy
  messageSupportOptionsEnglishAttending: MicroCopy
}
export type EnglishOrganizerSupportOptionsCopy = {
  headerSupportOptions: MicroCopy
  messageSupportOptionsEnglishOrganizing: MicroCopy
}

export type Props = {
  headerSupportOptions?: string
  messageSupportOptions?: string
  buttonCopy?: string
  userOrgs?: Options[]
  currentOrg?: Options
  toggleOrg?: (org: string) => void
  isTogglingOrg?: boolean
  variant?: "opportunity" | "warning" | "success" | "danger" | "info"
}

const SupportOptions: FC<Props> = ({
  headerSupportOptions,
  messageSupportOptions,
  buttonCopy,
  userOrgs,
  currentOrg,
  toggleOrg,
  isTogglingOrg,
  variant = "opportunity"
}) => {
  const clickHandler = useCallback(() => {
    navigate("https://eventbrite.com/organizations/plan-management")
  }, [])
  return (

    <div
      className={classNames({ [styles.supportOptions]: (userOrgs?.length ?? 0) <= 1 })}
    >
      {headerSupportOptions && messageSupportOptions && (
      <MarmaladeInlineAlert
        description={messageSupportOptions}
        icon={<InfoIcon size="medium" />}
        title={headerSupportOptions}
        variant={variant}
        cta={
          buttonCopy ? (
            <Button onClick={clickHandler} variant="ghost">
              {buttonCopy}
            </Button>
          ) : undefined
        }
      />
      )}
      {(userOrgs?.length ?? 0) > 1 ? (
        isTogglingOrg ? (
          <div style={{ height: 64 }} className={styles.switchOrgContainer}>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: greenLoaderLottieData,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice"
                }
              }}
              width={24}
              height={24}
            />
          </div>
        ) : (
          <div className={styles.switchOrgContainer}>
            <div className={styles.iconAndTextWrapper}>
              <span className={styles.iconWrapper}>
                <HelpIcon />
              </span>
              <Typography variant="body-md">
                Missing support options? Try switching organizations.
              </Typography>
            </div>
            <span className={styles.selectMenuWrapper}>
              <SelectField
                onChange={(orgId) => toggleOrg?.(orgId)}
                label={"Select organization"}
                name={"Select organization"}
                options={userOrgs ?? []}
                value={currentOrg?.value}
              />
            </span>
          </div>
        )
      ) : null}
    </div>
  )
}

export default SupportOptions
